import './elsieAiSummary.scss';
import WidgetAiMessageTemplate from '../widgets/widget-elsie-ai/WidgetAiMessageTemplate';
import { Chat, Message, User } from '@progress/kendo-react-conversational-ui';
import { selectUser } from '../../store/slices/auth.slice';
import { useSelector } from 'react-redux';

interface ElsieAISummaryProps {
  messages: Message[];
}

export function ElsieAISummary({ messages }: Readonly<ElsieAISummaryProps>) {
  const user = useSelector(selectUser);
  const currentUser: User = { id: user.email, name: user.externalName };
  const customMessage = () => <div></div>;

  return (
    <div className="elsie-summary-flyout-content">
      <Chat
        message={WidgetAiMessageTemplate}
        user={currentUser}
        messages={messages}
        messageBox={customMessage}
      />
    </div>
  );
}
